import React from 'react'
import BaseComponent from './BaseComponent'
import Parallax from 'parallax-js'
import Scroll from 'react-scroll'
import Footer from './Footer'
import $ from 'jquery'

let scroller = Scroll.scroller
let Element = Scroll.Element

export default class extends BaseComponent {

  constructor(props) {
  	super(props)
  	this.state = { show: false, item: -1, scroll: 0, offset: 0 }
  	this._bind('setContent', 'closeContent', 'onScroll')
    this.season = ""
    document.addEventListener("scroll", this.onScroll)
  }

  componentWillMount() {
    this.season = this.props.season
  }

  componentDidMount() {
  	let sceneLeft = document.getElementById('sceneLeft')
  	let parallaxInstanceLeft = new Parallax(sceneLeft)
  	let sceneRight = document.getElementById('sceneRight')
  	let parallaxInstanceRight = new Parallax(sceneRight)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    document.removeEventListener("scroll", this.onScroll)
  }

  onScroll(e) {
    this.setState({ scroll: document.body.scrollTop || document.documentElement.scrollTop })
  }

  setContent(id, e) {
    e.persist()
    $(".items li").css("margin-top", "0px")
    let offset = e.target.offsetTop + e.target.offsetHeight+10
    this.setState({ show: true, item: id, offset: offset }) 
  	setTimeout(() => {
      $(".items li").each((i, element) => {
        if (this.props.screen.width < 420) {
          if (i === id+1) {
            element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
          }
        } else if (this.props.screen.width < 614) {
          if (id < 2) {
            if (i === 2 || i === 3) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 4) {
            if (i === 4 || i === 5) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 6) {
            if (i === 6 || i === 7) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 8) {
            if (i === 8 || i === 9) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 10) {
            if (i === 10 || i === 11) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          }
        } else if (this.props.screen.width < 818) {
          if (id < 3) {
            if (i === 3 || i === 4 || i === 5) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 6) {
            if (i === 6 || i === 7 || i === 8) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 9) {
            if (i === 9 || i === 10 || i === 11) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 11) {
            if (i === 10 || i === 10 || i === 11) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          }
        } else if (this.props.screen.width < 1150) {
          if (id < 4) {
            if (i === 4 || i === 5 || i === 6 || i === 7) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 8) {
            if (i === 8 || i === 9 || i === 10 || i === 11) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 12) {
            if (i === 10 || i === 11 || i === 12) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          }
        } else {
          if (id < 5) {
            if (i === 5 || i === 6 || i === 7 || i === 8 || i === 9) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 10) {
            if (i === 10 || i === 11 || i === 12 || i === 13 || i === 14) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          } else if (id < 15) {
            if (i === 11 || i === 12 || i === 13 || i === 14) {
              element.style.marginTop = $(".item-content").outerHeight()+10 + "px"
            }
          }
        }
      })
    }, 400)
    //setTimeout(() => { this.scrollTo("content") }, 1100)
  }

  closeContent() {
  	this.setState({ show: false, offset: 0, item: -1 })
    $(".items li").css("margin-top", "0px")
  }

  scrollTo(el) {
    scroller.scrollTo(el, {
      duration: 1500,
      delay: 100,
      smooth: "easeInOutQuad",
      offset: -40
    })
  }

  render() {
    let data

    if (this.season === "winter") {
      data = this.props.data.winter
    } else {
      data = this.props.data.summer
    }

  	const items = data.items.map((item, i) => {
  		return (
  			<li key={ i } className={ this.state.item === i ? "item active" : "item" } onClick={ this.setContent.bind(null, i) }>
          <span className="number">{ i+1 }</span>
          <p dangerouslySetInnerHTML={{ __html: item.text }}></p>
          <img src={ item.icon } alt=""/>
          { this.season === "summer" ? <img className="h" src={ item.iconh } alt=""/> : <img className="h" src={ item.iconhb } alt=""/> }
        </li>
  		)
  	})

    return (
      <section className={ "home " + this.season }>
	    <div className="bg-left" id="sceneLeft" style={{ marginTop: this.state.scroll/1.5 + "px" }}>
	    	<div data-depth="0.2">{ this.season === "summer" ? <img src="/assets/img/sun-left.png" alt=""/> : <img src="/assets/img/snow-left-1.png" alt=""/> }</div>
	    	<div data-depth="0.4" className="clouds">{ this.season === "summer" ? <img src="/assets/img/clouds-left.png" alt=""/> : <img src="/assets/img/snow-left-2.png" alt=""/> }</div>
	    </div>
	    <div className="bg-right" id="sceneRight" style={{ marginTop: this.state.scroll/1.5 + "px" }}>
	    	<div data-depth="0.2">{ this.season === "summer" ? <img src="/assets/img/sun-right.png" alt=""/> : <img src="/assets/img/snow-right-1.png" alt=""/> }</div>
	    	<div data-depth="0.4" className="clouds">{ this.season === "summer" ? <img src="/assets/img/clouds-right.png" alt=""/> : <img src="/assets/img/snow-right-2.png" alt=""/> }</div>
	    </div>
        <div className="container">
        	<div className="slider">
        		<img className="slider-bg" src={ this.season === "winter" ? "/assets/img/slider-bg.jpg" : "/assets/img/slider-bg-summer.jpg" } alt=""/>
        		<h1>{ data.sliderTitle }</h1>
        		{ /* <img className="play" src="/assets/img/play.png" alt=""/> */ }
        	</div>
        	<div className="remember">
        		<p dangerouslySetInnerHTML={{ __html: data.remember1 }}></p>
        		<p dangerouslySetInnerHTML={{ __html: data.remember2 }}></p>
        	</div>
        	<div className="safety-rules">
        		<h2>{ data.safety1 }<br/><span>{ data.safety2 }</span></h2>
        		<img className="wheel" src="/assets/img/wheel-green.png" alt=""/>
        		<img className="wheel-winter" src="/assets/img/wheel-blue.png" alt=""/>
        	</div>
        	<div className="content-holder">
	        	<ul className={ this.season === "winter" ? "items" : "items summer" }>
	        		{ items }
              <li className="last"></li>
	        	</ul>
            <div className={ this.state.show ? "item-content show" : "item-content" } style={{ top: this.state.offset }}>
              <Element name="content"/>
              { this.state.item !== -1 ? <div dangerouslySetInnerHTML={{ __html: data.itemsContent[this.state.item] }}></div> : null }
              <div className="close" onClick={ this.closeContent }></div>
            </div>
	        </div>
        </div>
        <Footer lang={ this.props.lang }/>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/HomePage.js